import { useLocation } from '@reach/router';

export const useUtmParams = (): Record<string, string> => {
  const location = useLocation();
  const utmParams: Record<string, string> = {};
  new URLSearchParams(location.search).forEach((value, key) => {
    if (key.startsWith('utm_')) {
      utmParams[key] = value;
    }
  });
  return utmParams;
};

export const useUrlWithUtmParams = (url: string): string => {
  const utmParams = useUtmParams();
  const [baseUrl, existingParamsString] = url.split('?');
  const params = new URLSearchParams(existingParamsString);
  Object.entries(utmParams).forEach(([key, value]) => {
    params.append(key, value);
  });
  const newParamsString = params.toString();
  return newParamsString ? `${baseUrl}?${newParamsString}` : baseUrl;
};
